import React from 'react';
import { businessInfo, navLinks } from '../data/mock';
import { Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#302f2c] border-t border-[#4a2a10]/50">
      <div className="container mx-auto px-5 md:px-10">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <a href="#home" className="text-[#f97316] font-black text-2xl md:text-3xl tracking-tight block mb-4">
              {businessInfo.name}
            </a>
            <p className="text-[#888680] text-base leading-relaxed mb-6 max-w-md">
              {businessInfo.description}
            </p>
            <div className="flex items-center gap-3 text-[#888680]">
              <MapPin size={18} className="text-[#f97316] flex-shrink-0" />
              <span className="text-sm">{businessInfo.address}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#f97316] font-bold text-sm uppercase tracking-wide mb-6">Hızlı Linkler</h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  className="text-[#888680] hover:text-[#f97316] transition-colors duration-300 text-sm"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#f97316] font-bold text-sm uppercase tracking-wide mb-6">İletişim</h4>
            <div className="space-y-4">
              <a
                href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-2 text-[#f97316] hover:text-[#f97316]/80 transition-colors duration-300"
              >
                <Phone size={16} />
                <span className="font-semibold">{businessInfo.phone}</span>
              </a>
              <p className="text-[#888680] text-sm">
                {businessInfo.workingHours}
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-[#4a2a10]/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#888680] text-sm">
            © {currentYear} {businessInfo.name}. Tüm hakları saklıdır.
          </p>
          <p className="text-[#888680] text-sm">
            Eskişehir Küçük Ev Aletleri Tamir Servisi
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
